import React, {Fragment, useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import date from 'date-and-time';

import HeaderEjercicios from '../../AuxiliaresPaginas/HeaderEjercicios';
import Instrucciones from '../../Escritorio/Instrucciones';
import BotoneraBottom from '../Compartidos/BotoneraBottom';
import useConfigAuth from '../../../Hooks/useConfigAuth';

import { finalizarEjercicioAction, setearEjercicioAction } from '../../../actions/estadoEjercicioActions';
import { almacenarAction } from '../../../actions/almacenarEjercicioActions';

// css
import {Flex, Ilustracion } from '../../Css/MetodosCSS/StyledRimaLexica';
import { CirculoScreening } from '../../Css/MetodosCSS/StyledCCSilabica';
import { BtnColor, Img } from '../../Css/MetodosCSS/StyledLectoEscritura';
import { AvanzarBtn, AvanzarImg } from '../../Css/StyledMatematica';

const instrucciones = 'Vamos a escuchar una sílaba, tenemos que seleccionar en que parte de la palabra se encuentra, si al principio, en el medio, o al final (decirlo mientas se señalan los círculos)';
const miniInstrucciones = 'Identificar si el sonido se encuentra al principio , en el medio, o al final';

const SCR4 = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [config] = useConfigAuth();

    const [count, setCount] = useState(1);
    const [disable, setDisable] = useState(false);
    const [comparar, setComparar] = useState([]);
    const [indexes, setIndexes] = useState();
    const [contarTiempo, setContarTiempo] = useState([]);
    const [ultimoTiempo, setUltimoTiempo] = useState(false);
    const [resultado, setResultado] = useState([]);
    const [ejercicioElegido, setEjercicioElegido] = useState();
    const [elegido, setElegido] = useState();

    const iniciar = useSelector(state => state.ejercicio.iniciar);
    const finalizar = useSelector(state => state.ejercicio.finalizar);
    const id_paciente = useSelector((state) => state.usuario.id_paciente);
    const informacion = useSelector(state => state.informacion.info_DB);
    const ayuda_imagen = useSelector((state) => state.configuracion.ayuda_imagen);

    const resultadoBase = [
        {palabra_correcta:"", palabra_usada:"", puntaje:"", ejemplo:""},
        {palabra_correcta:"", palabra_usada:"", puntaje:"", ejemplo:""},
        {palabra_correcta:"", palabra_usada:"", puntaje:"", ejemplo:""},
        {palabra_correcta:"", palabra_usada:"", puntaje:"", ejemplo:""},
        {palabra_correcta:"", palabra_usada:"", puntaje:"", ejemplo:""},
        {palabra_correcta:"", palabra_usada:"", puntaje:"", ejemplo:""},
        {palabra_correcta:"", palabra_usada:"", puntaje:"", ejemplo:""},
        {palabra_correcta:"", palabra_usada:"", puntaje:"", ejemplo:""},
        {palabra_correcta:"", palabra_usada:"", puntaje:"", ejemplo:""}
    ];

    const play1 = () => {
        new Audio(`/sounds/${comparar.sonido_url_1}.mp3`).play();
    }

    const verificar = (e) => {
        e.preventDefault();
        if(!elegido) {
            return;
        }
        if(comparar.ejemplo == 1) {
            const newList = JSON.parse(JSON.stringify(resultado));
            newList[count-1].palabra_correcta = comparar.sonido_url_1;
            newList[count-1].palabra_usada = ejercicioElegido;
            newList[count-1].puntaje = "0";
            newList[count-1].ejemplo = 1;
            setResultado(newList);
            if(count < indexes) {
                setTimeout(() => {
                    setDisable(false);
                    setCount(count + 1);
                    setEjercicioElegido('');
                }, 100);
            } else {
                setUltimoTiempo(true);
                setTimeout(() => {
                    setDisable(false);
                    dispatch( finalizarEjercicioAction() )
                }, 100);
            }
            return
        }
        if(ejercicioElegido.toUpperCase() !== comparar.sonido_url_1.toUpperCase()) {
            console.log('mal');
            setDisable(true);
            const newList = JSON.parse(JSON.stringify(resultado));
            newList[count-1].palabra_correcta = comparar.sonido_url_1;
            newList[count-1].palabra_usada = ejercicioElegido;
            newList[count-1].puntaje = "0";
            newList[count-1].ejemplo = 0;
            setResultado(newList);
            if(count < indexes) {
                setTimeout(() => {
                    setDisable(false);
                    setCount(count + 1);
                    setEjercicioElegido('');
                }, 100);
            } else {
                setUltimoTiempo(true);
                setTimeout(() => {
                    setDisable(false);
                    dispatch( finalizarEjercicioAction() )
                }, 100);
            }
        } else {
            console.log("bien");
            setDisable(true);
            const newList = JSON.parse(JSON.stringify(resultado));
            newList[count-1].palabra_correcta = comparar.sonido_url_1;
            newList[count-1].palabra_usada = ejercicioElegido;
            newList[count-1].puntaje = "1";
            newList[count-1].ejemplo = 0;
            setResultado(newList);
            if(count < indexes) {
                setTimeout(() => {
                    setDisable(false);
                    setCount(count + 1);
                    setEjercicioElegido('');
                }, 100);
            } else {
                setUltimoTiempo(true);
                setTimeout(() => {
                    setDisable(false);
                    dispatch( finalizarEjercicioAction() )
                }, 100);
            }
        }
    }

    useEffect(() => {
        dispatch(setearEjercicioAction('SCR4') );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        setComparar(informacion[count-1]);
        setIndexes(Object.keys(informacion).length);
    }, [count, informacion])

    useEffect(() => {
        setResultado(resultadoBase);
    }, [informacion])

    useEffect(() => {
        if(iniciar === false && count === indexes){
            return;
        }else if(iniciar === false && count === 1){
            return;
        } else {
            const newList = JSON.parse(JSON.stringify(contarTiempo));
            newList.push(new Date());
            setContarTiempo(newList);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [iniciar,count, ultimoTiempo]);

    useEffect(() => {
        if(finalizar){
            const tiempo = JSON.parse(JSON.stringify(contarTiempo));
            const conseguirTiempos = (a) => {
                const t = [];
                for (let i = 0; i < a.length - 1; i++){
                    const despues = new Date(a[i+1]);
                    const antes = new Date(a[i])
                    const segundos = Math.round((date.subtract(despues, antes).toSeconds())*10)/10;
                    t.push(segundos);
                }
                return t
            }
            const tiempoFinal = conseguirTiempos(tiempo);

            const informacion = {
                config,
                payload: {
                    'screening': true,
                    'tiempo': tiempoFinal,
                    'ejercicio': "SCR4",
                    'resultado': resultado,
                    'id_paciente': id_paciente
                }
            }
            dispatch( almacenarAction(informacion) );
            navigate("/escritorio/metodos/finalizar-ejercicio");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [finalizar]);

    return (
        <Fragment>
            <HeaderEjercicios estrellas={true} carrito={true} ayuImagen={true} />
            {iniciar
                ?   
                <Fragment>
                    <Flex direction="column" height="100%">
                        {comparar.ejemplo ? 
                        <Flex margin="1rem 0 0 2rem" style={{fontSize:"40px", fontFamily:"Nunito", fontWeight:"bold", justifyContent:"start" }}>
                            Ejemplo
                        </Flex>
                        : null
                        }
                        <Flex justify="space-evenly" margin="auto">
                            <Flex margin="0 4rem 0 0">
                                <audio src={`/sounds/${comparar.sonido_url_1}.mp3`} autoPlay />
                                <BtnColor border="none" bg="transparent" 
                                    onClick={() => play1()}
                                >
                                    <Img alt='' w="70px" src={`/img/altavoz.png`} />
                                </BtnColor>
                            </Flex>
                            
                            <Flex height="100%" direction="column">
                                <Flex margin="3rem 0px 4rem 0px" direction="column">
                                    <Ilustracion src={`/img/${comparar.imagen_url_1}.png`} width="15vw"/>
                                    {ayuda_imagen ? 
                                        <div>{comparar.ayuda_imagen_1}</div>
                                    : null}
                                </Flex>
                                
                                <Flex direction="row">
                                    <CirculoScreening backgroundcolor="#23AAAF" style={{border: elegido === "1"? "black" : null, borderColor: elegido === "1"? "black" : null, borderStyle: elegido === "1"? "solid" : null}}
                                        disabled={disable}
                                        onClick={() => (setEjercicioElegido(comparar.palabra_1), setElegido("1"))}
                                    >
                                    </CirculoScreening>
                                    <CirculoScreening backgroundcolor="#FFB526" style={{border: elegido === "2" ? "black" : null, borderColor: elegido === "2" ? "black" : null, borderStyle: elegido === "2" ? "solid" : null}}
                                        disabled={disable}
                                        onClick={() => (setEjercicioElegido(comparar.palabra_2), setElegido("2"))}
                                    >
                                    </CirculoScreening>
                                    {comparar.palabra_3 ?
                                    <CirculoScreening backgroundcolor="#FE6363" style={{border: elegido === "3" ? "black" : null, borderColor: elegido === "3" ? "black" : null, borderStyle: elegido === "3" ? "solid" : null}}
                                        disabled={disable}
                                        onClick={() => (setEjercicioElegido(comparar.palabra_3), setElegido("3"))}
                                    >
                                    </CirculoScreening>
                                    :
                                    null
                                    }
                                    {comparar.palabra_4 ?
                                    <CirculoScreening backgroundcolor="#9A5EE8" style={{border: elegido === "4" ? "black" : null, borderColor: elegido === "4" ? "black" : null, borderStyle: elegido === "4" ? "solid" : null}}
                                        disabled={disable}
                                        onClick={() => (setEjercicioElegido(comparar.palabra_4), setElegido("4"))}
                                    >
                                    </CirculoScreening>
                                    :
                                    null
                                    }
                                </Flex>
                            </Flex>
                        </Flex>
                        <Flex margin="0 0rem 0 0rem" width="90%" justify="space-between" display="flex" align="center">
                            <BotoneraBottom miniInstrucciones={miniInstrucciones} />
                            <AvanzarBtn
                                disabled={disable}
                                onClick={(e) => (verificar(e), setElegido(''))}
                                
                            >
                                <AvanzarImg src={'/img/play.png'} /> 
                            </AvanzarBtn>
                        </Flex>
                    </Flex>
                </Fragment>
                :
                    <Instrucciones instrucciones={instrucciones} />
            }
        </Fragment>
    );
}
 
export default SCR4;